import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

let domain = window.location.hostname;
document.title = extractBaseDomain(domain);
let faveIcon = document.getElementById("fave-icon") as HTMLAnchorElement;

if(domain.includes("pulsyai") && faveIcon){
  faveIcon.href = "assets/pulsy-favicon.png"
}else if(faveIcon){
  faveIcon.href = "assets/default-faveicon.jpg"
}
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
function extractBaseDomain(domain: string): string {
  // Remove www.
  domain = domain.replace(/^www\./, '');

  // Split by dots
  const parts = domain.split('.');

  // Handle known country-code TLDs (like .co.uk)
  const tlds = ['co.uk', 'com.au', 'co.in', 'co.jp', 'com.br'];
  const lastTwo = parts.slice(-2).join('.');
  if (tlds.includes(lastTwo)) {
    return parts[parts.length - 3] || '';
  }

  // Default: return second-to-last part (root domain)
  return parts.length >= 2 ? parts[parts.length - 2] : domain;
}
